/*
 * This file is auto-generated by ./bin/rails stimulus:manifest:update
 * Run that command whenever you add a new controller or create them with
 * ./bin/rails generate stimulus controllerName
 */

import {application} from "./application";

import ChecklistItemController from "./checklist_item_controller";
application.register("checklist-item", ChecklistItemController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import HotkeysController from "./hotkeys_controller";
application.register("hotkeys", HotkeysController);
